import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { notEmptyRegex } from '../../utils/regex';
import ValidCookieForm from '../Home/ValidCookieForm';

import './ResetPassword.css';
import {
  setPassword1InResetForm,
  setPassword2InResetForm,
} from '../../actions/userActions';
import { setViewMessages } from '../../actions/viewActions';
import {
  updatePassword,
  verifyResetKey,
  sendResetPasswordEmail,
  checkAuth,
} from '../../utils/data';
import {
  segmentEnum,
  track,
  clickedElement,
  trackPage,
} from '../../utils/segment';
import { gotoPageAfterXSecond } from '../../utils/commons';

const customerCareLink = 'https://support.fabfitfun.com/hc/en-us/requests/new';
const defaultMsg = (
  <span>
    Something is incorrect.{' '}
    <a className="lost" href={customerCareLink}>
      Contact our customer support
    </a>
  </span>
);

class ResetPassword extends Component {
  state = {
    isUpdating: false,
    isResetting: false,
    isValidResetKey: false,
    successMessage: null,
    resetKey: null,
    email: null,
    isLoading: true,
    isUpdateSuccess: false,
    isValidCookie: false,
    isResetPasswordRequired: false,
    passwordValidateErrorMessages: [],
  };

  componentDidMount() {
    this.props.setViewMessages([]);
    //Verify cookie and switch view accordingly
    checkAuth((res) => {
      var isValidCookie = true,
        hasValidCookie = true;
      if (!origin || !res.ok) {
        isValidCookie = false;
        hasValidCookie = false;
        let newSearchUrl = new URLSearchParams(this.props.location.search);
        let resetKey = newSearchUrl.get('key');
        let email = newSearchUrl.get('login');
        let isResetPasswordRequired = newSearchUrl.get(
          'isResetPasswordRequired'
        );
        if (isResetPasswordRequired === 'true') {
          this.setState({
            ...this.state,
            isResetPasswordRequired: true,
            isLoading: false,
          });
        } else if (resetKey && email) {
          this.setState({ ...this.state, resetKey: resetKey, email: email });
          verifyResetKey(resetKey, email).then((res) => {
            if (res.status) {
              switch (res.status) {
                case 200:
                  this.setState({
                    ...this.state,
                    isValidResetKey: true,
                    isLoading: false,
                  });
                  break;
                case 400:
                  this.setState({
                    ...this.state,
                    isValidResetKey: false,
                    isLoading: false,
                  });
                  this.props.setViewMessages([
                    <span>
                      <strong>This password reset link has expired.</strong>{' '}
                      Please check your inbox and spam folder to confirm that
                      you are clicking on the most recent password reset link
                      sent to you. You can also request a new reset link below.
                    </span>,
                  ]);
                  break;

                default:
                  this.setState({
                    ...this.state,
                    isValidResetKey: false,
                    isLoading: false,
                  });
                  this.props.setViewMessages([defaultMsg]);
              }
            }
          });
        } else {
          this.setState({ ...this.state, isLoading: false });
        }
      }

      this.setState({ ...this.state, isValidCookie: isValidCookie });
      trackPage(null, 'Reset Passsword', { has_valid_cookie: hasValidCookie });
    });

    // Bind Analytic Trackig Events
    clickedElement({
      target_element: document.getElementsByClassName('reset-password-button'),
      data: {
        element_name: 'Reset Password',
        option_title: 'User sends themselves a password reset email',
      },
    });

    clickedElement({
      target_element: document.getElementsByClassName('update-password-button'),
      data: {
        element_name: 'Update Password',
        option_title: 'User update password',
      },
    });
  }

  handleUpdatePassword1 = (e) => {
    this.props.setPassword1InResetForm(e.target.value);
  };

  handleUpdatePassword2 = (e) => {
    this.props.setPassword2InResetForm(e.target.value);
    if (this.props.password_1 !== e.target.value) {
      this.setState({
        ...this.state,
        passwordValidateErrorMessages: ['Passwords do not match.'],
      });
    } else {
      this.setState({ ...this.state, passwordValidateErrorMessages: [] });
    }
  };

  handleChangeEmail = (e) => {
    this.setState({ ...this.state, email: e.target.value });
  };

  handleResetPassword = () => {
    this.setState({ ...this.state, isResetting: true });

    sendResetPasswordEmail(this.state.email).then((res) => {
      this.setState({
        ...this.state,
        isResetting: false,
      });
      if (res.status) {
        switch (res.status) {
          case 200:
            this.props.setViewMessages([]);
            track(segmentEnum.SendResetPasswordEmail, {
              success: true,
            });

            this.setState({
              ...this.state,
              successMessage:
                'Link sent! Check your inbox and SPAM folder for your reset link.',
            });
            break;
          case 400:
          case 422:
            track(segmentEnum.SendResetPasswordEmail, {
              success: false,
              failed_reason: 'Invalid username or e-mail.',
            });
            this.setState({
              ...this.state,
              successMessage: null,
            });
            this.props.setViewMessages([
              <span>Invalid username or e-mail.</span>,
            ]);
            break;

          default:
            this.props.setViewMessages([defaultMsg]);
        }
      }
    });
  };

  handleResetPasswordKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleResetPassword();
      e.preventDefault();
    }
  };

  processSuccessUpdatePassword = (origin) => {
    this.setState({ ...this.state, isUpdateSuccess: true });
  };

  handleUpdatePasswordToServer = (e) => {
    const notEmptyPassword1 = notEmptyRegex.test(this.props.password_1);
    const notEmptyPassword2 = notEmptyRegex.test(this.props.password_2);
    const inputValidation = [];

    if (!notEmptyPassword1 || !notEmptyPassword2) {
      if (!notEmptyPassword1) {
        inputValidation.push('Password is required.');
      } else {
        inputValidation.push('Confirm password is required.');
      }
    }

    if (this.props.password_1 !== this.props.password_2) {
      inputValidation.push('Passwords do not match.');
    }

    if (inputValidation.length > 0) {
      this.setState({
        ...this.state,
        passwordValidateErrorMessages: inputValidation,
      });
      return;
    }

    this.setState({ ...this.state, passwordValidateErrorMessages: [] });
    const { password_1 } = this.props;
    const { resetKey, email } = this.state;
    this.setState({ ...this.state, isUpdating: true });
    updatePassword(email, password_1, resetKey).then((res) => {
      this.setState({ ...this.state, isUpdating: false });
      if (res.status) {
        switch (res.status) {
          case 200:
            this.props.setViewMessages([]);
            this.processSuccessUpdatePassword(origin);
            track(segmentEnum.CreateNewPassword, {
              success: true,
            });
            gotoPageAfterXSecond({
              goto_url: '../',
            });
            break;
          case 400:
          case 422:
            res.json().then((json) => {
              if (json.errors) {
                this.props.setViewMessages(json.errors);
              } else {
                this.props.setViewMessages([defaultMsg]);
              }
            });
            this.props.setViewMessages([defaultMsg]);
            track(segmentEnum.CreateNewPassword, {
              success: false,
              failed_reason: 'Error message from response',
            });
            break;

          default:
            this.props.setViewMessages([defaultMsg]);
        }
      }
    });
  };

  render() {
    const {
      handleUpdatePassword1,
      handleUpdatePassword2,
      handleUpdatePasswordToServer,
      handleResetPassword,
      handleChangeEmail,
      handleResetPasswordKeyDown,
    } = this;

    const {
      isValidResetKey,
      isUpdating,
      isLoading,
      isResetting,
      successMessage,
      isUpdateSuccess,
      isValidCookie,
      isResetPasswordRequired,
      passwordValidateErrorMessages,
    } = this.state;

    return (
      <React.Fragment>
        {isValidCookie ? (
          <ValidCookieForm />
        ) : (
          <>
            {!isLoading && (
              <div className="update-password-page mar-a">
                {isUpdateSuccess ? (
                  <div className="update-password">
                    <div className="success-message">
                      <i className="fas fa-check-circle" /> Password updated
                      successfully.
                    </div>
                    <div className="description">
                      Your password has been successfully updated. You will be
                      redirected to the login page to sign in with your new
                      password.
                    </div>
                    <div className="redirect-icon">
                      <i className="far fa-spinner fa-spin" />
                    </div>
                  </div>
                ) : (
                  <>
                    {isValidResetKey ? (
                      <div className="update-password">
                        <h2 className="update-password-page-h2">
                          Password Reset
                        </h2>
                        <p className="form-description">
                          Create a new password below
                        </p>
                        <form>
                          <div className="labelpair">
                            <label htmlFor="password">
                              New Password
                              <span>*</span>
                            </label>
                            <input
                              name="password_1"
                              type="password"
                              onChange={handleUpdatePassword1}
                            />
                          </div>
                          <p className="form-row">
                            <label className="pwd-policy">
                              Please set a new password for your account that
                              you have not used elsewhere. Choose a strong
                              password that has at least 8 characters, with a
                              minimum of 1 number, 1 uppercase, 1 lowercase, and
                              1 special character.
                            </label>
                          </p>
                          <div className="labelpair">
                            <label htmlFor="password">
                              Re-enter new password
                              <span>*</span>
                            </label>
                            <input
                              name="password_2"
                              type="password"
                              onChange={handleUpdatePassword2}
                            />
                          </div>
                          <div className="messages">
                            {this.props.messages.map((msg, index) => (
                              <div className="message" key={'message-' + index}>
                                <b>ERROR:</b> {msg}
                              </div>
                            ))}
                            {passwordValidateErrorMessages.map((msg, index) => (
                              <div className="message" key={'message-' + index}>
                                {msg}
                              </div>
                            ))}
                          </div>
                        </form>
                        <button
                          className="update-password-button"
                          type="button"
                          onClick={handleUpdatePasswordToServer}
                          disabled={isUpdating}
                        >
                          {isUpdating ? (
                            <>
                              UPDATING...
                              <i className="far fa-spinner fa-spin" />
                            </>
                          ) : (
                            <>UPDATE PASSWORD</>
                          )}
                        </button>
                      </div>
                    ) : (
                      <div className="reset-password">
                        <div className="messages">
                          {this.props.messages.map((msg, index) => (
                            <div className="message" key={'message-' + index}>
                              {msg}
                            </div>
                          ))}
                        </div>
                        {successMessage && (
                          <div className="success-message">
                            {successMessage}
                          </div>
                        )}
                        <p className="title">
                          {isResetPasswordRequired ? (
                            <>
                              As a security measure, we're requiring that you
                              change your password. Please enter your email and
                              click the button below.
                            </>
                          ) : (
                            <>
                              To reset your password, please enter your
                              FabFitFun email address below.
                            </>
                          )}
                        </p>
                        <p className="description">
                          You will receive a link to create a new password via
                          email - check your Inbox and SPAM folder for the reset
                          link. If you have any questions or issues resetting
                          your password, you may contact us{' '}
                          <a className="lost" href={customerCareLink}>
                            here
                          </a>
                          .
                        </p>
                        <form>
                          <div className="labelpair">
                            <label htmlFor="password">
                              Your FabFitFun email address:
                              <span>*</span>
                            </label>
                            <input
                              name="email"
                              type="email"
                              onChange={handleChangeEmail}
                              onKeyDown={handleResetPasswordKeyDown}
                            />
                          </div>
                        </form>
                        <button
                          className="reset-password-button"
                          type="button"
                          disabled={isResetting}
                          onClick={handleResetPassword}
                        >
                          {isResetting ? (
                            <>
                              RESET PASSWORD...
                              <i className="far fa-spinner fa-spin" />
                            </>
                          ) : (
                            <>RESET PASSWORD</>
                          )}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mS = (state) => ({
  password_1: state.user.password_1,
  password_2: state.user.password_2,
  messages: state.view.messages,
});

const mD = (dispatch) =>
  bindActionCreators(
    {
      setPassword1InResetForm,
      setPassword2InResetForm,
      setViewMessages,
    },
    dispatch
  );

export default connect(mS, mD)(ResetPassword);
